import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "utils/api";
import { getSessionData } from "utils/common";

const initialState = {
  marginSummary: null,
  marginSummaryLoading: false,
};

const sessionUserId = () => {
  const s = getSessionData() || {};
  return Number(s.userId ?? s.UserId ?? s.id ?? s.Id ?? 0) || 0;
};

/** §11.1 — Balance / Credit / Equity / P&L / Used / Free / Holding / Level */
export const getMarginSummary = createAsyncThunk("margin/summary", (forUserId) => {
  const sessionId = sessionUserId();
  const targetId = forUserId || sessionId;
  const url = targetId ? `margin/summary/${targetId}` : "margin/summary";
  return new Promise((resolve, reject) => {
    api
      .get(url)
      .then((res) => {
        const body = res?.data;
        if (body?.status === 200) resolve(body.data || null);
        else reject(body);
      })
      .catch(reject);
  });
});

const margin = createSlice({
  name: "margin",
  initialState,
  reducers: {
    clearMarginSummary: (state) => {
      state.marginSummary = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMarginSummary.pending, (state) => {
        state.marginSummaryLoading = true;
      })
      .addCase(getMarginSummary.fulfilled, (state, action) => {
        const summary = action.payload;
        if (!summary) {
          state.marginSummaryLoading = false;
          return;
        }
        const summaryUserId = Number(summary.userId ?? summary.UserId ?? 0);
        const requestedId = action.meta?.arg;
        const sessionId = sessionUserId();
        const isSelfFetch = !requestedId || Number(requestedId) === sessionId;
        if (isSelfFetch && sessionId > 0 && summaryUserId > 0 && summaryUserId !== sessionId) {
          state.marginSummaryLoading = false;
          return;
        }
        state.marginSummary = summary;
        state.marginSummaryLoading = false;
      })
      .addCase(getMarginSummary.rejected, (state) => {
        state.marginSummaryLoading = false;
      });
  },
});

export const { clearMarginSummary } = margin.actions;
export default margin.reducer;
